import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useWatchListService = () => {
    // eslint-disable-next-line
    const [watchListService, setWatchListService] = useState<any>();
    useEffect(() => {
        const angularJsInjector = getInjector();
        const _watchListService = angularJsInjector.get('WatchlistService');
        setWatchListService({..._watchListService});
    }, []);

    return { watchListService };
};
export default useWatchListService;
